require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-artisan-park-opens-this-weekend.json") })
        }
      }, "path---news-artisan-park-opens-this-weekend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-artisan-park-opens-this-weekend!./.cache/json/news-artisan-park-opens-this-weekend.json
// module id = 789
// module chunks = 231608221292675